import script from "./SubMenuSearch.vue?vue&type=script&setup=true&lang=js"
export * from "./SubMenuSearch.vue?vue&type=script&setup=true&lang=js"

import "./SubMenuSearch.vue?vue&type=style&index=0&id=530ecb31&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-530ecb31"]])

export default __exports__